import { render, staticRenderFns } from "./BrandingReportSetting.vue?vue&type=template&id=ebdf0230"
import script from "./BrandingReportSetting.vue?vue&type=script&lang=js"
export * from "./BrandingReportSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports